import {ID, Response} from '../../../../../../../_metronic/helpers'

export type Dealer = {
  id?:ID
  erp_id?: string
  division_id?: number
  division_name?: string
  warehouse_name?: string
  warehouse_id?: number
  dealer_name?: string
  address?: string
  phone_number?: string
  email?: string
  tax_number?:string
  license_number?: string
  status?:string
  zone_id?: number
  zone_name?:string
  gst_in_number?: string
  state_id?: number
  state_name?: string
  city_id?: number
  city_name?: string
  district_id?: number
  district_name?: string
}


export type DealerQueryResponse = Response<Array<Dealer>>

export const initialDealer: Dealer = {
  erp_id:'',
  division_id:0,
  division_name:'',
  warehouse_id:0,
  warehouse_name:'',
  dealer_name: '',
  address: '',
  phone_number: '',
  email: '',
  tax_number:'',
  license_number: '', 
  status:'',
  zone_id:0,
  zone_name:'',
  gst_in_number:'',
  state_id:0,
  state_name:'',
  city_id:0,
  city_name:'',
  district_id:0,
  district_name:'',
}

